import { useAtom } from "jotai";

import { gql } from "@apollo/client";
import { useNorthbeamMutationPromise } from "@hooks/http";
import {
  type DismissMMMAlert,
  type DismissMMMAlertVariables,
} from "@north-beam/nb-client-side";

import { AlertsAtom, useGlobalMMMStore } from "../mmm-provider";

const DISMISS_MMM_ALERT = gql`
  mutation DismissMMMAlert($alertId: ID!) {
    dismissMMMAlert(alertId: $alertId) {
      id
      dismissed_at
    }
  }
`;

export const useAlerts = () => {
  const GlobalMMMStore = useGlobalMMMStore();
  const [alerts, setAlerts] = useAtom(AlertsAtom, {
    store: GlobalMMMStore,
  });

  const [_dismissAlert] = useNorthbeamMutationPromise<
    DismissMMMAlert,
    DismissMMMAlertVariables
  >(DISMISS_MMM_ALERT);

  const dismissAlert = async (alertId: string) => {
    try {
      setAlerts((prev) =>
        prev.map((alert) =>
          alert.id === alertId
            ? { ...alert, dismissed_at: new Date().toISOString() }
            : alert,
        ),
      );
      const { dismissMMMAlert: newAlert } = await _dismissAlert({ alertId });
      setAlerts((prev) =>
        prev.map((alert) =>
          alert.id === newAlert.id ? { ...alert, ...newAlert } : alert,
        ),
      );
    } catch (err) {
      setAlerts((prevAlerts) =>
        prevAlerts.map((alert) =>
          alert.id === alertId ? { ...alert, dismissed_at: null } : alert,
        ),
      );
      // TODO: Handle error U/I
    }
  };

  return [alerts, setAlerts, { dismissAlert }] as const;
};
